import React from "react";
import documents from "../../img/icon--documents.svg";
import papers from "../../img/icon--papers.svg";
import validators from "../../img/icon--validators.svg";

export default function CenteredText({ content }) {
	if (content.secondaryCtaUrl && content.secondaryCtaText && content.thirdCtaUrl && content.thirdCtaText) {
		return (
			<section className='today' key={content.id}>
				<div className='container'>
					<div className='d-flex row'>
						<div className='col-lg-5 col-md-12 mb-md-5 mb-lg-0'>
							<h2>{content.title}</h2>
						</div>
						<div className='col-lg-6 offset-lg-1 col-md-12'>
							<div className='today--elements'>
								<div className="item">
									<a href={content.ctaUrl} target={content.isExternal ? '_blank' : '_self'}>
										<div className='d-flex align-items-center'>
											<div className='image-box'>
												<img src={documents} alt='' />
											</div>
											<div>{content.ctaText}</div>
											<div>
												<i className='fas fa-arrow-right' />
											</div>
										</div>
									</a>
								</div>

								<div className="item">
									<a href={content.secondaryCtaUrl} target={content.isSecondaryExternal ? '_blank' : '_self'}>
										<div className='d-flex align-items-center'>
											<div className='image-box'>
												<img src={papers} alt='' />
											</div>
											<div>{content.secondaryCtaText}</div>
											<div>
												<i className='fas fa-arrow-right' />
											</div>
										</div>
									</a>
								</div>

								<div className="item">
									<a href={content.thirdCtaUrl} target={content.isThirdExternal ? '_blank' : '_self'}>
										<div className='d-flex align-items-center'>
											<div className='image-box'>
												<img src={validators} alt='' />
											</div>
											<div>{content.thirdCtaText}</div>
											<div>
												<i className='fas fa-arrow-right' />
											</div>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
	return (
		<section key={content.id} className='centered-text-section bg-gray'>
			<div className='container'>
				<div className='row justify-content-center'>
					<div className='col col-12 col-sm-8 col-md-8 text-center'>
						<h2 className='mb-4'>{content.title}</h2>
					</div>
				</div>
				<div className='row justify-content-center'>
					<div className='col-auto'>
						<a href={content.ctaUrl} className='btn'>
							{content.ctaText}
						</a>
					</div>
				</div>
			</div>
		</section>
	);
}
